import {
    PHOTOGRAPHERS_FETCH_REQUEST,
    PHOTOGRAPHERS_FETCH_SUCCESS,
    PHOTOGRAPHERS_FETCH_FAILURE,
    PHOTOGRAPHERS_EQ_FETCH_REQUEST,
    PHOTOGRAPHERS_EQ_FETCH_SUCCESS,
    PHOTOGRAPHERS_EQ_FETCH_FAILURE
} from './types';

const initialState = {
    loading: false,
    photographers: {},
    error: ''
}

const photographers = (state = initialState, action) => {
    switch (action.type) {
        case PHOTOGRAPHERS_FETCH_REQUEST:
            return {
                loading: true,
                photographers: {},
                error: '',
            }
        case PHOTOGRAPHERS_FETCH_SUCCESS:
            return {
                loading: false,
                photographers: action.payload,
                error: ''
            }
        case PHOTOGRAPHERS_FETCH_FAILURE:
            return {
                loading: false,
                photographers: {},
                error: action.payload
            }
        default:
            return state
    }
}

const initialEqState = {
    loading: false,
    data: {},
    error: ''
}


function updateObject(oldObject, newValues) {
    return Object.assign({}, oldObject, newValues)
}


function updateItemInArray(array, itemId, updateItemCallback) {
    const updatedItems = array.data.data.records.map(item => {
        if (item.book_id !== itemId) {
            return item
        }
        const updatedItem = updateItemCallback(item)
        return updatedItem
    })
    return updatedItems
}


const photographersEq = (state = initialEqState, action) => {
    switch (action.type) {
        case PHOTOGRAPHERS_EQ_FETCH_REQUEST:
            return {
                loading: true,
                data: {},
                error: '',
            }
        case PHOTOGRAPHERS_EQ_FETCH_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: ''
            }
        case PHOTOGRAPHERS_EQ_FETCH_FAILURE:
            return {
                loading: false,
                data: {},
                error: action.payload
            }
            // case PHOTOGRAPHERS_EQ_FETCH_REQUEST:
            //     {
            //         const newDatas = updateItemInArray(state.photographers, action.id, item => {
            //             return updateObject(item, { loading: true })
            //         })
            //         return updateObject(state, {
            //             photographers: {
            //                 ...state.photographers,
            //                 photographers: {
            //                     records: newDatas
            //                 }
            //             }
            //         })
            //     }
        default:
            return state
    }
}

export { photographers, photographersEq };